import type { IPayment } from "@/assets/ts/interfaces/payment/IPayment";

export class Payment {
	constructor(public data: IPayment) {}
}
